import { render, staticRenderFns } from "./ColorPickerField.vue?vue&type=template&id=532a14c8&scoped=true&"
import script from "./ColorPickerField.vue?vue&type=script&lang=js&"
export * from "./ColorPickerField.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerField.vue?vue&type=style&index=0&id=532a14c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a14c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VColorPicker,VIcon,VMenu,VTextField})
